import { render, staticRenderFns } from "./Benchmarks.vue?vue&type=template&id=22a90076&"
import script from "./Benchmarks.vue?vue&type=script&lang=js&"
export * from "./Benchmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports